import React from 'react';
import { Paragraph } from '../../../../typography';
import { FormattedMessage, useIntl } from 'react-intl';

const Confirmation = React.memo(({ selectedUsers, messages, files, isGroup = false, groupName = '' }) => {
    const intl = useIntl();

    /** A conversa pode ser iniciada só com anexo, só com mensagem, ou com os dois:
     *  o resumo lista apenas o que o usuário de fato escolheu.
     */
    const attachments = files || [];
    const contentSummary = [
        messages.length > 0 && (messages.length === 1 ? '1 mensagem' : `${messages.length} mensagens`),
        attachments.length > 0 && (attachments.length === 1 ? '1 anexo' : `${attachments.length} anexos`)
    ].filter(Boolean).join(' e ');

    /** No grupo a mensagem é opcional: ele pode ser criado vazio. O criador não está
     *  entre os participantes escolhidos, porque entra sozinho, como gestor.
     */
    if (isGroup) {
        return (
            <div className="p-1">
                <Paragraph>
                    <FormattedMessage
                        id="Ao confirmar, o grupo {name} será criado com {count} participante(s), e você entrará nele como gestor."
                        values={{
                            name: <strong>{groupName.trim()}</strong>,
                            count: selectedUsers.length
                        }} />
                </Paragraph>
                <Paragraph>{contentSummary ?
                    intl.formatMessage({ id: "Confirma a criação do grupo e o envio de {messages}?" }, { messages: contentSummary }) :
                    intl.formatMessage({ id: "Confirma a criação do grupo?" })}
                </Paragraph>
            </div>
        )
    }

    return (
        <div className="p-1">
            <Paragraph>{ intl.formatMessage({
                id: "Ao enviar {messages}, você iniciará um chat {users}."
                }, {
                    messages: messages.length === 1 && attachments.length === 0 ? 'essa mensagem' : `esse conteúdo`,
                    users: selectedUsers.length === 1 ? 'com o usuário selecionado' : `com cada um dos usuários selecionados`
                })}</Paragraph>
            <Paragraph>{ intl.formatMessage({
                id: "Confirma o envio de {messages} para {users}?"
            }, {
                messages: contentSummary,
                users: selectedUsers.length === 1 ? '1 usuário' : `${selectedUsers.length} usuários`
            })}</Paragraph>
        </div>
    )
});

export default Confirmation;
